/**
 * 防抖
 * 短时间内多次触发同一事件（函数），只执行最后一次 ，或者只执行第一次，中间的不执行
 * @param callback    {function}  需要执行的方法
 * @param time        {number}    间隔时间(毫秒)
 * @param inFront     {boolean}   是否在开头执行
 * @returns {(function(): void)}
 */
export function debounce(callback,time = 1000, inFront = true){
  let target = 0;
  if(typeof callback !== "function") return function(){};
  if(typeof time !== "number" || time < 0) time = 1000;
  return function(){
    if(target) clearTimeout(target);
    else if(inFront) callback.apply(this,arguments); // 在最开始执行
    target = setTimeout(()=>{
      target = 0;
      if(!inFront) callback.apply(this,arguments); // 在最后执行
    },time);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/my-tools-kit/src/modules/debounce.js
// module id = LE40
// module chunks = 37